<template>
    <div id="packer_layout">
        <div v-if="is_initialized">
            <div class="ui equal width grid">
                <div class="column">
                    <CommandPanel
                    :is_processing="is_processing"
                    :scanner_modes="scanner_modes"
                    :current_scanner_mode="current_scanner_mode"
                    />
                    <div class="ui divider"></div>
                    <CurrentPack
                    :current_pack="current_pack"
                    :parent_pack="current_pack_parent_pack"
                    />
                    <div class="ui divider"></div>
                    <SelectedPack
                    :selected_pack="selected_pack"
                    :parent_pack="selected_pack_parent_pack"
                    />
                </div>
                <div class="column">
                    <Workspace
                    :packs="packs"
                    :selected_pack="selected_pack"
                    :all_packs="packer_store.packs"
                    :is_processing="is_processing"
                    />
                </div>
            </div>
        </div>
        <div v-else class="ui active centered inline large loader"></div>
    </div>
</template>

<script>
import Workspace from "./components/pack/workspace.vue"
import CommandPanel from "./components/pack/command_panel.vue"
import CurrentPack from "./components/pack/current_pack.vue"
import SelectedPack from "./components/pack/selected_pack.vue"
export default {
    data: function() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
        packer_store: function() {
            return  this.$store.state.packer_module.pack_mode;
        },
        scanner_modes: function() {
            return this.packer_store.scanner_modes;
        },
        current_scanner_mode: function() {
            return this.packer_store.current_scanner_mode;
        },
        packs: function() {
            return _.filter(this.packer_store.packs, {"packed_by_number": null});
        },
        selected_pack: function() {
            return this.packer_store.selected_pack;
        },
        selected_pack_parent_pack: function() {
            return _.find(this.packer_store.packs, {'core_waybill_number': this.packer_store.selected_pack.packed_by_number});
        },
        current_pack: function() {
            return this.packer_store.current_pack;
        },
        current_pack_parent_pack: function() {
            return _.find(this.packer_store.packs, {'core_waybill_number': this.packer_store.current_pack.packed_by_number});
        },
        is_processing: function() {
            return this.packer_store.is_processing;
        },
    },
    watch: {
        '$route' (to, from) {
            this.set_breadcrumbs();
        }
    },
    created: function() {
        
        this.init();
        this.set_breadcrumbs();
    },
    mounted: function() {
        
        var that = this;

        that.$bus.$off("packer_command_center");
        that.$bus.$on("packer_command_center", function(action, params) {
            console.log("packer_command_center:" + action + params);
            switch (action) {
                case "commands":
                    that.commands(params);
                    break;
                case "change_scanner_mode":
                    that.change_scanner_mode(params);
                    break;
                case "packing":
                    that.packing(params);
                    break;
                case "selection":
                    that.selection(params);
                    break;
                case "remove_pack":
                    that.remove_pack(params);
                    break;
                case "escape_pack":
                    that.escape_pack(params);
                    break;
                case "submit":
                    that.submit();
                    break;
                default:
            }
        }.bind(this));
    },
    methods: {
        init: function() {
            var that = this;
            const promise = new Promise(function(resolve, reject) {
                resolve();
            })

            promise.then(function() {
                that.is_initialized = false;
            }).then(function() {
                that.change_scanner_mode(that.scanner_modes[0]);
            }).then(function() {
                that.packer_store.workspace_identity = that.$store.state.provider.stations[4].workspaces[0].identity;
            }).then(function() {
                return that.get_packs();
            }).then(function() {
                that.$noty.information("打包界面初始化完畢");
                that.is_initialized = true;
            }).catch(function (error) {
                switch (error) {
                    default:

                }
            });
        },
        get_packs: function() {
            var that = this;
            var url = new RestUrl(that.$store.state.shipper_routes.api_v1_provider_workspace_workflows).parse(
                {
                    workspace_identity: that.packer_store.workspace_identity
                },
                '?authorization=' + that.$store.state.shipper.authorization
            )

            return axios.get(url)
                .then(function (response) {
                    that.packer_store.packs = _.map(response.data.workflows, function(workflow) {
                         return _.extend({}, workflow, {packed_by_number: null});
                    });
                    that.$noty.success('已抓取workflows.')
                })
                .catch(function (error) {
                    that.$noty.error('Failed to fetch workflows.')
                });
        },
        set_breadcrumbs: function() {
            var that = this;
            var packer = {
                route_name: "packer",
                name: "打包界面"
            }

            switch (that.$route.name) {
                case "packer":
                    that.$store.state.breadcrumbs = [packer]
                    break;
            }
        },
        // CommandCenter
        commands: function(barcode) {
            var that = this;

            switch (barcode) {
                case "##tally":
                    that.change_scanner_mode("tally");
                    break;
                case "##addition":
                    that.change_scanner_mode("addition");
                    break;
                case "##selection":
                    that.change_scanner_mode("selection");
                    break;
                case "##packing":
                    that.change_scanner_mode("packing");
                    break;
                default:
                    switch (that.packer_store.current_scanner_mode) {
                        case "tally":
                            that.tally(barcode);
                            break;
                        case "addition":
                            that.addition(barcode);
                            break;
                        case "selection":
                            that.selection(barcode);
                            break;
                        case "packing":
                            that.packing(barcode);
                            break;
                        default:
                            that.$noty.error("尚未選擇模式");
                    }
            }
        },
        change_scanner_mode: function(mode) {
            var that = this;
            switch (mode) {
                case "down":
                    var current_index = _.indexOf(that.scanner_modes, that.packer_store.current_scanner_mode);
                    if (that.scanner_modes[current_index + 1]) {
                        that.packer_store.current_scanner_mode = that.scanner_modes[current_index + 1];
                    } else {
                        that.packer_store.current_scanner_mode = _.head(that.scanner_modes);
                    }
                    that.$noty.success("切換模式：" + that.$t('packer.' + that.packer_store.current_scanner_mode));
                    break;
                case "up":
                    var current_index = _.indexOf(that.scanner_modes, that.packer_store.current_scanner_mode);
                    if (that.scanner_modes[current_index - 1]) {
                        that.packer_store.current_scanner_mode = that.scanner_modes[current_index - 1];
                    } else {
                        that.packer_store.current_scanner_mode = _.last(that.scanner_modes);
                    }
                    that.$noty.success("切換模式：" + that.$t('packer.' + that.packer_store.current_scanner_mode));
                    break;
                default:
                    that.packer_store.current_scanner_mode = mode;
                    that.$noty.success("切換模式：" + that.$t('packer.' + mode));
            }
        },
        tally: function(number) {
            var that = this;
            if (that.is_legal_input(number)) {
                var existing_one = _.find(this.packer_store.packs, {'core_waybill_number': number});
                if (existing_one) {
                    // 若該貨物已存在工作區
                    that.$noty.information("此貨物已點");
                } else if (true) {
                    // 若點貨成功
                    that.packer_store.packs.push({
                        number: number,
                        packed_by_number: null,
                    });

                    that.packer_store.current_pack = _.find(this.packer_store.packs, {'core_waybill_number': number});
                } else {
                    // 若點貨失敗
                    that.$noty.error("查無此貨");
                }
            }
        },
        addition: function(number) {
            var that = this;
            if (that.is_legal_input(number)) {
                var existing_one = _.find(this.packer_store.packs, {'core_waybill_number': number});
                if (existing_one) {
                    // 若該包已存在工作區
                    that.$noty.information("此包已存在");
                } else if (true) {
                    // 若加包成功
                    that.packer_store.packs.push({
                        core_waybill_number: number,
                        packed_by_number: null,
                    });

                    that.packer_store.current_pack = _.find(this.packer_store.packs, {'core_waybill_number': number});
                } else {
                    // 若加包失敗
                    that.$noty.error("查無此包");
                }
            }
        },
        selection: function(number) {
            var that = this;
            if (that.is_legal_input(number)) {
                var result = _.find(that.packer_store.packs, {'core_waybill_number': number});
                if (result) {
                    that.packer_store.selected_pack = result;
                    that.packer_store.current_pack = result;
                } else {
                    that.$noty.error("此號碼尚未進入工作區，請以點貨或加包模式加入後再繼續");
                }
            }
        },
        packing: function(number) {
            var that = this;
            if (that.is_legal_input(number)) {
                if (Object.keys(that.packer_store.selected_pack).length != 0) {
                    if (number != that.packer_store.selected_pack.core_waybill_number) {
                        if (that.is_packable(number)) {
                            var target = _.find(that.packer_store.packs, {'core_waybill_number': number});
                            if (target) {
                                target.packed_by_number = that.packer_store.selected_pack.core_waybill_number;
                                that.packer_store.current_pack = target;
                            } else {
                                that.$noty.error("查無此貨");
                            }
                        } else {
                            that.$noty.error("子不可包親");
                        }
                    } else {
                        that.$noty.error("不能自己包裝自己");
                    }
                } else {
                    that.$noty.error("請先選包");
                }
            }
        },
        remove_pack: function(number) {
            var that = this;
            var pack = _.find(that.packer_store.packs, {'core_waybill_number': number});
            if (that.is_legal_input(number)) {
                if (confirm("刪除包裝會釋放出底下的子包，確定刪除？")) {
                    // 清空selected_pack
                    if (that.packer_store.selected_pack == pack) {
                        that.packer_store.selected_pack = {};
                    }
                    // 釋放子包
                    var children_packs = _.filter(that.packer_store.packs, {"packed_by_number": pack.core_waybill_number});
                    _.forEach(children_packs, function(pack) {
                        pack.packed_by_number = null;
                    });
                    // 將該包從packs中移除
                    that.packer_store.packs.splice(that.packer_store.packs.indexOf(pack), 1);
                }
            }
        },
        escape_pack: function(number) {
            var that = this;
            if (that.is_legal_input(number)) {
                var pack = _.find(that.packer_store.packs, {'core_waybill_number': number});
                if (pack.packed_by_number == null) {
                    that.$noty.information(pack.core_waybill_number + "不在任何包裝裡");
                } else {
                    pack.packed_by_number = null;
                }
            }
        },
        is_packable: function(number) {
            var that = this;
            var selected_pack = that.packer_store.selected_pack;

            if (selected_pack.packed_by_number) {
                while (selected_pack.packed_by_number) {
                    if (selected_pack.packed_by_number == number) {
                        // 當某階段的上層是要包的對象時（子包親）
                        return false;
                    } else {
                        selected_pack = _.find(that.packer_store.packs, {'core_waybill_number': selected_pack.packed_by_number});
                        if (selected_pack.packed_by_number) {
                            // 有更上層時，繼續遞迴檢查
                            continue;
                        } else {
                            // 沒有更上層時
                            return true;
                        }
                    }
                }
            } else {
                // 當Pack是最外層時可包任何東西
                return true;
            }
        },
        is_legal_input: function(input) {
            var that = this;
            if (input) {
                if (input.replace(/\s/g, '').length) {
                    return true;
                } else {
                    that.$noty.error("無效的輸入");
                    return false;
                }
            } else {
                that.$noty.error("請輸入號碼");
                return false;
            }
        },
        submit: function() {
            var that = this;
            that.packer_store.is_processing = true;
            var url = new RestUrl(that.$store.state.shipper_routes.api_v1_provider_workspace_packing).parse(
                {
                    "workspace_identity": that.packer_store.workspace_identity
                },
                "?authorization=" + that.$store.state.shipper.authorization
            );
            var params = _.map(that.packer_store.packs, function(pack) {
                return _.extend({}, {
                    "core_waybill_number": pack.core_waybill_number,
                    "packed_by_number": pack.packed_by_number,
                }, {})
            });
            console.log(params);
            axios.post(url, {
                packs: params
            }).then(function (response) {
                if (response.data.status == "success") {
                    that.packer_store.is_processing = false;
                    that.$noty.success("打包成功");
                } else {
                    that.packer_store.is_processing = false;
                    that.$noty.error("打包失敗");
                }
            })
            .catch(function (error) {
                if (!error.response) {
                    // Network Error
                    that.packer_store.is_processing = false;
                    that.$noty.error(
                        that.$t('ui.general.network_abnormality')+": "+
                        that.$t('ui.general.server_offline')
                    );
                } else {
                    that.packer_store.is_processing = false;
                    that.$noty.error(that.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data);
                }
            });
        }
    },
    components: {
        Workspace,
        CommandPanel,
        CurrentPack,
        SelectedPack,
    }
}
</script>
